import PageNotFound from "../../../components/PageNotFound";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var NoFoundPlaceholder = function NoFoundPlaceholder(_ref) {
  var layoutConfig = _ref.layoutConfig;
  return layoutConfig.pageNotFoundFallback ? /*#__PURE__*/_jsx(_Fragment, {
    children: layoutConfig.pageNotFoundFallback(layoutConfig)
  }) : /*#__PURE__*/_jsx(PageNotFound, {});
};